import * as React from 'react';
import { core_apimessages_Address } from '../../../schemas/rql';
import { AddressSummaryWithCountries } from '../address_summary';

interface IProps {
  loading: boolean;
  address: core_apimessages_Address;
}

export default class ShippingAddress extends React.Component<IProps, null> {
  renderPlaceholder() {
    return (
      <p className="formatted-address formatted-address--placeholder">
        <span className="formatted-address__highlight" />
      </p>
    );
  }

  render() {
    if (this.props.loading) { return this.renderPlaceholder(); }

    const { address } = this.props;

    return <AddressSummaryWithCountries address={address} />;
  }
}



// WEBPACK FOOTER //
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/discovery-ui/src/components/addresses/checkout/shipping_address.tsx